import { z } from "zod";

// Zod Schemas for API validation

const PoliticalGroupSchema = z.object({
  idAgrupacion: z.coerce.number(),
  nombreAgrupacion: z.string(),
  votos: z.coerce.number(),
  votosPorcentaje: z.coerce.number(),
  idAgrupacionTelegrama: z.string().optional(),
  urlLogo: z.string().optional(),
});

const EstadoRecuentoSchema = z.object({
  mesasEsperadas: z.coerce.number(),
  mesasTotalizadas: z.coerce.number(),
  mesasTotalizadasPorcentaje: z.coerce.number(),
  cantidadElectores: z.coerce.number().optional(),
  cantidadVotantes: z.coerce.number().optional(),
  participacionPorcentaje: z.coerce.number().optional(),
});

const ValoresOtrosSchema = z.object({
  votosNulos: z.coerce.number(),
  votosNulosPorcentaje: z.coerce.number(),
  votosEnBlanco: z.coerce.number(),
  votosEnBlancoPorcentaje: z.coerce.number(),
  votosRecurridosComandoImpugnados: z.coerce.number().optional(),
  votosRecurridosComandoImpugnadosPorcentaje: z.coerce.number().optional(),
});

export const ElectoralResultsSchema = z.object({
  fechaTotalizacion: z.string(),
  estadoRecuento: EstadoRecuentoSchema,
  valoresTotalizadosPositivos: z.array(PoliticalGroupSchema),
  valoresTotalizadosOtros: ValoresOtrosSchema,
});

// Type exports

export type ElectoralResults = z.infer<typeof ElectoralResultsSchema>;
export type PoliticalGroup = z.infer<typeof PoliticalGroupSchema>;
export type EstadoRecuento = z.infer<typeof EstadoRecuentoSchema>;
export type ValoresOtros = z.infer<typeof ValoresOtrosSchema>;

export interface HistoricalComparisonData {
  general: ElectoralResults | null;
  // runoff: ElectoralResults | null;
  generalCircuito: ElectoralResults | null;
  // runoffCircuito: ElectoralResults | null;
  error?: string;
}

// Utility functions

const removeDiacritics = (value: string) =>
  value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export const normalizeName = (value: string) =>
  removeDiacritics(value).toUpperCase().replace(/\s+/g, " ").trim();

/**
 * Parse and validate the electoral API response
 */
export function parseElectoralResponse(data: unknown): ElectoralResults | null {
  const parsed = ElectoralResultsSchema.safeParse(data);

  if (!parsed.success) {
    console.warn(
      "Invalid electoral API payload received",
      parsed.error.flatten(),
    );
    return null;
  }

  return parsed.data;
}
